import React from 'react';

class RadioList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div></div>);
    }
}

RadioList.defaultProps = {

};

RadioList.PropTypes = {

};

export default RadioList;



// WEBPACK FOOTER //
// ./src/components/Field_Components/RadioList/RadioList.js